import { routerFrom } from "router";

export const routes = [
  {
    acl: ["MANAGER", "ADMIN"],
    label: "Contract Details",
    name: "contracts.details",
    path: "/app/contracts/:contractId",
  },
  {
    acl: ["MANAGER", "ADMIN"],
    label: "Contract Details Details",
    name: "contracts.details.details",
    path: `/app/contracts/:contractId/?tab=details`,
  },
  {
    acl: ["MANAGER", "ADMIN"],
    label: "Contract Tasks",
    name: "contracts.details.tasks",
    path: `/app/contracts/:contractId/?tab=tasks`,
  },
  {
    acl: ["MANAGER", "ADMIN"],
    label: "Contracts List",
    name: "contracts",
    path: "/app/contracts",
  },
];

export const router = routerFrom(routes);
